<template>
  <div class="main-wrap notice">
    <div class="container">
      <div class="row notice-header">
        <div class="col">
          <div class="_left">
            <div class="__logo"><img src="@/assets/image/no_logo.png" /></div>
            <div class="__title">皇太后餐點管理系統</div>
          </div>
          <div class="_right">
            <div class="_icoBox">
              <a href="https://bigmama.casaloma.cc/" target="_blank"><img src="@/assets/image/i1.svg" /></a>
              <a href="https://www.facebook.com/Huang.Tai.Hou.No1/" target="_blank"><img src="@/assets/image/i2.svg" /></a>
              <a href="https://www.instagram.com/huang.tai.hou/" target="_blank"><img src="@/assets/image/i3.svg" /></a>
            </div>
            <p>公司名稱：{{ acgencyInfo.name }}</p>
            <p>公司統編：{{ acgencyInfo.number}}</p>
            <p>公司電話：{{ acgencyInfo.phone_prefix + ' - ' + acgencyInfo.phone}}</p>
            <p>公司傳真：{{ acgencyInfo.fax_prefix + ' - ' + acgencyInfo.fax }}</p>
            <p>電子信箱：{{ acgencyInfo.email}}</p>
          </div>
        </div>
        <div class="col">
          <div class="_left">
            <div class="_n">負責業務</div>
            <div class="_t">
              <div>{{ acgencyInfo.employee?acgencyInfo.employee.name:'' }}</div>
              <div>{{ acgencyInfo.employee?acgencyInfo.employee.phone:'' }}</div>
            </div>
          </div>
          <div class="_right _qr">
            <img src="@/assets/image/no-qr.png" />
          </div>
        </div>
      </div>

      <div class="notice-title">皇太后公告</div>
      <div class="notice-body">
        <el-table
            stripe
            class="notice-table"
            :data="tableData"
            header-row-class-name="custom-filter"
            header-cell-class-name="aaa"
            style="width: 100%">
          <el-table-column
              prop="start_at"
              label="公告時間"
              align="center"
              width="180">
            <template v-slot="{row}">
               {{ row.start_at.replaceAll('-','/') + ' - ' + row.end_at.replaceAll('-','/')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="date1"
              label="公告類型"
              align="center"
              filter-placement="bottom-end"
              width="180">
            <template v-slot="{row}">
               {{ typeList.find(item => item.id == row.type).name}}
            </template>
          </el-table-column>
          <el-table-column
              prop="date2"
              label="公告標題">
            <template v-slot="scope">
              <div class="type-box">
                <span style="margin-left: 10px">{{ scope.row.title }}</span>
                <router-link :to="`/NoticeDetails?id=${scope.row.id}`" class="a-tag">檢視詳情</router-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="statusName"
              align="center"
              width="180"
              label="公告狀態">
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
              layout="prev, pager, next"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { agencyMessage } from "@/api";

export default {
  name: "Notice",
  data() {
    return {
      acgencyInfo: JSON.parse(window.localStorage.getItem('agency_info')),
      tableData: [],
      form:{
        page:1,
        limit:10
      },
      total: 0,
      typeList:[
        {id:1,name:'系統公告'},
        {id:2,name:'皇太后公告'},
        {id:3,name:'業務公告'},
        {id:4,name:'優惠方案'}
      ]
    }
  },
  created() {

  },
  mounted() {
    this.getagencyMessage()
  },
  beforeDestroy() {
  },
  methods:{
    filterTag(value, row) {
      return row.tag === value;
    },
    getagencyMessage(){
      agencyMessage(this.form).then(res =>{
           this.tableData = res.data.list
           this.total = res.data.total
        this.tableData.map(item =>{
           let dataTime = new Date().getTime()
          let startTime = new  Date(item.start_at).getTime()
          let endTime = new  Date(item.end_at).getTime()
          if(dataTime > endTime){
             item.statusName = '已過期'
          }else if(startTime < dataTime && dataTime < endTime){
            item.statusName = '發佈中'
          }else if(startTime > dataTime){
            item.statusName = '未開始'
          }
          return item
        })
      })
    },
    handleCurrentChange(val) {
     this.form.page = val
      this.getagencyMessage()
    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
